import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { FlagsProvider } from '@atlaskit/flag';
import { fg } from '@atlaskit/platform-feature-flags';
import { sendScreenEvent, sendTrackEvent, sendUIEvent } from '../../../common/utils/analytics-client';
import { BSCIntlProvider } from '../../../common/utils/locale';
import { Logger } from '../../../common/utils/logger';
import { ONLY_NECESSARY_PREFERENCES } from '../../../constants';
import { updatePreferences } from '../../../controllers/preferences-controls/update-preferences';
import { PresentationalPreferenceModal } from './presentational-preference-modal';
import usePreferences from './use-preferences';
export var PreferenceModal = function PreferenceModal(props) {
  if (fg('platform_moonjelly_bsc_master_killswitch') || fg('platform_moonjelly_bsc_ui_killswitch')) {
    // Don't render the preference modal if the killswitch is enabled
    return null;
  }
  return /*#__PURE__*/React.createElement(PreferenceModalImpl, props);
};
export var PreferenceModalImpl = function PreferenceModalImpl(_ref) {
  var onClose = _ref.onClose,
    onSubmit = _ref.onSubmit,
    showSuccessFlag = _ref.showSuccessFlag,
    showErrorFlag = _ref.showErrorFlag,
    _ref$shouldAddWrapper = _ref.shouldAddWrappers,
    shouldAddWrappers = _ref$shouldAddWrapper === void 0 ? true : _ref$shouldAddWrapper;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isModalOpen = _useState2[0],
    setIsModalOpen = _useState2[1];
  var isEventSent = useRef(false);
  useEffect(function () {
    if (!isEventSent.current) {
      sendScreenEvent({
        name: 'cookieConsentModal'
      });
      isEventSent.current = true;
    }
  }, [isEventSent]);
  var _usePreferences = usePreferences({}),
    preferences = _usePreferences.preferences,
    setPreferencesData = _usePreferences.setPreferencesData;

  // If we don't have preferences, set default preferences
  // for modal interactions
  if (!preferences) {
    setPreferencesData({
      prefs: ONLY_NECESSARY_PREFERENCES,
      isPrefetchedPrefsInternalState: false
    });
  }
  var handleOnSubmit = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(displayedTextMap) {
      var selectedPreferences;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!preferences) {
              _context.next = 18;
              break;
            }
            selectedPreferences = preferences;
            sendUIEvent({
              action: 'clicked',
              actionSubject: 'button',
              actionSubjectId: 'confirm',
              source: 'cookieConsentModal'
            });
            _context.prev = 3;
            _context.next = 6;
            return updatePreferences(selectedPreferences, displayedTextMap);
          case 6:
            sendTrackEvent({
              source: 'cookieConsentModal',
              action: 'submitted',
              actionSubject: 'cookieConsentPreferences'
            });
            showSuccessFlag === null || showSuccessFlag === void 0 || showSuccessFlag();
            _context.next = 14;
            break;
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](3);
            Logger.errorWithOperationalEvent({
              action: 'updatePreferencesError',
              attributes: {
                preferences: selectedPreferences
              },
              message: "Failed to update preferences from modal. ".concat(_context.t0.message || '')
            });
            showErrorFlag === null || showErrorFlag === void 0 || showErrorFlag();
          case 14:
            setIsModalOpen(false);
            onSubmit === null || onSubmit === void 0 || onSubmit();
            _context.next = 19;
            break;
          case 18:
            // Preferences have reached an invalid state, show error flag
            showErrorFlag === null || showErrorFlag === void 0 || showErrorFlag();
          case 19:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 10]]);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [preferences, onSubmit, showSuccessFlag, showErrorFlag]);
  var modalContent = /*#__PURE__*/React.createElement(PresentationalPreferenceModal, {
    onSubmit: handleOnSubmit,
    onClose: onClose,
    setIsOpen: setIsModalOpen,
    preferences: preferences !== null && preferences !== void 0 ? preferences : ONLY_NECESSARY_PREFERENCES,
    setPreferencesData: setPreferencesData
  });
  if (!isModalOpen) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, shouldAddWrappers && fg('cpals_translation_issue_in_modal') ? /*#__PURE__*/React.createElement(FlagsProvider, null, /*#__PURE__*/React.createElement(BSCIntlProvider, null, modalContent)) : modalContent);
};